module.exports = __webpack_public_path__ + "img/download-icon.2295bb2a.svg";